import { configureStore } from '@reduxjs/toolkit';
import paymentReducer from './paymentSlice.js';

const store = configureStore({
    reducer: {
        payment: paymentReducer,
    },
});

export default store;
